import {DropdownSelectData} from "app/Interface/Component/Form"
import AuthApiService from "app/Service/Auth/AuthApiService"
import UserService, {subscribeUser} from "app/Service/ClientUser/UserService"
import EnvironmentService, {subscribeEnv} from "app/Service/System/EnvironmentService"
import SystemModuleService, {subscribeSystemModule} from "app/Service/System/Module/SystemModuleService"
import SystemModuleUiService from "app/Service/System/Module/SystemModuleUiService"
import DropdownNavigation from "app/WebController/Component/Nav/DropdownNavigation"
import {Module} from "const/Module"
import Logger from "logger/logger"
import React, {useEffect, useState} from "react"
import {useTranslation} from "react-i18next"
import {useNavigate} from "react-router-dom"

function Avatar() {

  const {t} = useTranslation('Components.Avatar')

  const navigate = useNavigate()

  const {logout} = AuthApiService()

  const {navigateSettings} = SystemModuleUiService([], 'Avatar')

  const {languageLoading} = EnvironmentService([
    subscribeEnv.language
  ], 'Avatar')

  const {userName, userRoles} = UserService([
    subscribeUser.userName,
    subscribeUser.roles
  ], 'Avatar')

  const {systemModules, getSystemModuleByName} = SystemModuleService([
    subscribeSystemModule.systemModules
  ], 'Avatar')

  const [menu, setMenu] = useState<DropdownSelectData[]>([])

  useEffect(() => {
    Logger('Element.Avatar.init')
    return () => {
      Logger('Element.Avatar.unloading')
    }
  }, [])

  useEffect(() => {
    const menu = []

    if (systemModules.length > 0 && userRoles.length > 0) {
      systemModules.sort((a, b) => a.order - b.order).map(sm => {
        if (sm.type === Module.system)
          menu.push({id: sm.path, name: t(sm.name, {ns: "Module.Modules"}), active: false})
      })
    }

    menu.push({
      id: `logout`,
      name: t('logout'),
      active: false
    })

    setMenu(menu)

  }, [systemModules, userRoles, languageLoading])

  function handleChange(option: DropdownSelectData | undefined) {
    if (!option) return
    switch (option.id) {
      case 'logout':
        return logout()
      case Module.user:
        const userModule = getSystemModuleByName(Module.user)
        navigateSettings(Module.userMyAccount, userModule.id)
        return navigate(`/${userModule.path}`)
      case Module.client:
        const clientModule = getSystemModuleByName(Module.client)
        navigateSettings(Module.clientMyAccount, clientModule.id)
        return navigate(`/${clientModule.path}`)
      case Module.system:
        const systemModule = getSystemModuleByName(Module.system)
        navigateSettings(Module.systemSettings, systemModule.id)
        return navigate(`/${systemModule.path}`)
    }
  }

  return (
    <DropdownNavigation
      id={'avatar'}
      onChange={handleChange}
      options={menu}
      title={userName ?? 'Loading...'}
    />
  )
}

export default Avatar
